import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getAgencyData = createAsyncThunk(
  "agency/getAgencyData",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/Agency${params}`
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAgencyIdByCode = createAsyncThunk(
  "agency/getAgencyIdByCode",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/Agency/getAgencyIdByCode${params}`
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAgentProfile = createAsyncThunk(
  "agent/getAgentProfile",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agent/getAgentProfile`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAgencies = createAsyncThunk(
  "agent/getAgencies",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agency/getAgencies`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAgencyDataProfile = createAsyncThunk(
  "agent/getAgencyDataProfile",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agency/getAgencyDataProfile`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addBorderAgency = createAsyncThunk(
  "agent/addBorderAgency",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agency/addBorder`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteBorderAgency = createAsyncThunk(
  "agent/deleteBorderAgency",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agency/deleteBorder`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const saveAgency = createAsyncThunk(
  "agent/saveAgency",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Agency/saveAgency`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAgentProfile = createAsyncThunk(
  "agent/updateAgent",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.put(`${BASE_URL}/Agent/updateAgent`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);